<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
        :visible.sync="dialogVisi"
        width="70%"
        :destroy-on-close="true"
        :before-close="handleClose">
            <el-dialog
      width="70%"
      title="分配角色"
      :visible.sync="innerVisible"
      append-to-body>
      <div style="100%;height:500px">
           <div style="width:30%;height:500px;border-right:1px solid;float:left;">
             <div style="margin-bottom:30px">
               所在部门：
             </div>
           <el-tree :data="osData"   accordion :props="defaultProps" @node-click="handleNodeClick"></el-tree>
        </div>
        <div style="width:30%;height:500px;border-right:1px solid;float:left;">
          <div>
            待选人员：
          </div>
          <div style="margin-top:30px">
            <el-select
    v-model="selectedVal"
    style="margin-left: 20px;"
    @change="selected()"
    placeholder="请选择人员">
    <el-option
      v-for="item in selectedOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </div>
        </div>
        <div style="width:30%;height:500px;float:left;">
          <div>
            已选人员：
          </div>
    <div style="margin-top:30px">
            <el-select
    v-model="constraintVal"
    multiple
    collapse-tags
    style="margin-left: 20px;"
    placeholder="请选择人员">
    <el-option
      v-for="item in constraint"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </div>
        </div>
      </div>
   <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button type="primary" @click="innerble()" >确 定 </el-button>
      </span>
    </el-dialog>
    <div style="width:100%;min-height:400px">
      <div style="width:100%;height:50px;">
        <p>角色名称：{{this.res.roleName}}</p>
        <br/>
        <p>归属机构：{{this.res.officeName}}</p>
        <br/>
        <p>数据范围：{{this.res.dataScopeName}}</p>
      </div>
      <div class="allocation" @click="allocation">
        分配角色
      </div>
  <el-table  :data="tableData"  v-loading="loading"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  tooltip-effect="light"    style="margin-bottom: 20px;overflow-y: scroll;float:right;margin-top:30px" row-key="id" border  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column show-overflow-tooltip prop="companyName" label="归属公司"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="officeName" label="归属部门"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="loginName" label="登录名" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="userName" label="姓名"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="userPhone" label="电话"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="userMobile" label="手机" ></el-table-column>
     <el-table-column fixed="right" label="操作">
     <template slot-scope="scope">
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small" title="移除"  v-debounce></el-button>
        </template>
    </el-table-column>
  </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px">
    </el-pagination>
    </div>
 <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisi = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "RoleManagementAllocation",
  data() {
    return {
    dialogVisi: false,
    title:"标题",
    res:{},
       total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
    tableData:[],
    loading:false,
    innerVisible:false,
    osData:[],
    defaultProps: {
      children: 'children',
      label: 'officeName'
    },
    selectedVal:"",
    selectedOptions:[],
    constraint:[],
    constraintVal:"",
    };
  },
  watch:{
      dialogVisi(val){
        if(val != false){
          if(this.res.dataScope == "1"){
            this.res.dataScopeName = "所有数据"
          }else if(this.res.dataScope == "2"){
            this.res.dataScopeName = "所在公司及以下数据"
          }else if(this.res.dataScope == "3"){
            this.res.dataScopeName = "所在公司数据"
          }else if(this.res.dataScope == "4"){
            this.res.dataScopeName = "所在部门及以下数据"
          }else if(this.res.dataScope == "5"){
            this.res.dataScopeName = "所在部门数据"
          }else if(this.res.dataScope == "6"){
            this.res.dataScopeName = "所在项目及以下数据"
          }else if(this.res.dataScope == "7"){
            this.res.dataScopeName = "所在小区及以下数据"
          }else if(this.res.dataScope == "8"){
            this.res.dataScopeName = "仅本人数据"
          }else if(this.res.dataScope == "9"){
            this.res.dataScopeName = "按明细设置"
          }
          this.loading = true
            this.ShareList()
        }
      },
      innerVisible(val){
        if(val != false){
        }
      }
  },
  methods: {
    ShareList(){
         let obj = {
                "roleId": this.res.roleId,
                "page":this.currentPage, // 当前页
                "size":this.pagesize,  // 每页大小
                }
        this.$http.post(this.$requestUrl.GET_USER_ROLE,obj).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.total = result.total
          this.loading = false
          this.tableData = result.data.records
        }else{
           this.loading = false
          this.$message.error(result.msg)
        }
      }).catch(() => {
         this.loading = false
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
        handleSizeChange(val) {
        this.pagesize = val
        this.ShareList()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.ShareList()
    },
    delMenu(row){
        this.$confirm('是否确认要删除该用户?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let obj = {
              "roleId":this.res.roleId,
              "userId":row.userId
            }
         this.$http.delete(this.$requestUrl.DELETE_USER_ROLE,obj).then((res) => {
          if(res.data.code == 200){
                 this.$message({
            type: 'success',
            message: '删除成功!'
          });
            this.loading = true
            this.ShareList()
          }else{
            this.ShareList()
          this.$message({
            type: 'warning',
            message: '删除失败'
          });
          }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
              }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    modification(){
        this.dialogVisi = false
    },
    allocation(){
      this.innerVisible = true
    },
    innerble(){
       let obj = {
                "roleId":this.res.roleId,
                "userId":this.constraintVal.toString()
                }
         this.$http.post(this.$requestUrl.POST_ROLE_ADD_USER,obj).then((res) => {
          if(res.data.code == 200){
            this.$message({
            type: 'success',
            message: '分配成功!'
          });
            this.innerVisible = false
          }else{
                  this.innerVisible = false
          this.$message({
            type: 'warning',
            message: '分配失败'
          });
          }
      })
    },
    handleNodeClick(data){
         let obj = {
          "officeId":data.officeId,
        }
         this.$http.post(this.$requestUrl.POST_STAFF,obj).then((res) => {
          if(res.data.code == 200){
            let data = res.data.data;
            for(let val of data){
              val.label = val.userName
              val.value = val.userId
            }
            this.selectedOptions = data
          }
      })
    },
    selected(){
      for(let val of this.selectedOptions){
        if(val.value == this.selectedVal){
          this.constraint.push(val)
        }
      }
      this.unique(this.constraint)
      let array = []
      for(let res of this.constraint){
        array.push(res.value)
      }
      this.constraintVal = array
    },
      unique(arr){            
        for(var i=0; i<arr.length; i++){
            for(var j=i+1; j<arr.length; j++){
                if(arr[i]==arr[j]){   
                    arr.splice(j,1);
                    j--;
                }
            }
        }
return arr;
},
  },
    mounted() {
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
  },
}
</script>

<style scoped lang="scss">
.commonDialogBody {
    position: relative;
}
.commonDiaDiv{
    position:absolute;
    width:50%; 
    height: 500px;
    // border:1px solid;
    top: 90px;
    right: 45px;
}
.allocation{
float:right;width:80px;height:35px;border:1px solid;background: #246CE5;color:#fff;border-radius:9px; line-height: 35px;text-align: center;
  -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
}
</style>